/**
 *  g2.lys.ElementLayer  代理图层
 *  添加自己的事件分发机制，并且保持G.base.Class的代码风格，
 *  且 ElementLayerProxy原型继承 g2.lys.ElementLayer
 *  追加mouseover和mouseout事件
 *  添加在元素上鼠标变小手、离开时变鼠标。
 *  解决元素双击时，触发地图
 *  解决双击图标会触发两次单击事件。
 *  遗留
 *  问题一：虽然可以关闭地图双击放大的事件，但是，不能屏蔽其他双击事件.
 */
/**
 * 图层代理类
 * @module ElementLayerProxy
 */
'use strict';
define(['../base/Class', '../misc/AppEvent', '../map/Map','../g2'], function (Class, AppEvent, Gmap,g2) {
    /**
     *  g2.carto.ElementLayer  代理图层
     *  添加自己的事件分发机制，并且保持G.base.Class的代码风格，
     *  且 ElementLayerProxy原型继承 g2.carto.ElementLayer
     * 构造方法
     * @constructor
     * @classdesc 图层代理类
     * @augments g2.carto.ElementLayer
     * @augments G.base.Class
     * @alias G.lys.ElementLayerProxy
     * @param {Object} options - 必填，构造参数；
     * @param {bool} options.hasEvent - 可选，是否开启图层事件代理
     * @returns {Class} 实例化的对象
     */
    function ElementLayerProxy(opt) {
        g2.carto.ElementLayer.call(this, opt)
    }
    //ElementLayerProxy原型方法
    ElementLayerProxy.prototype = {
        options: {
            hasEvent: false
        },
        constructor: ElementLayerProxy,
        /**
         *添加此图层到地图，
         * @method
         * @memberOf G.lys.ElementLayerProxy.prototype
         * @param  {g2.carto.Map} options.map -必填，地图对象
         */
        addTo: function (g2map) {
            if (g2map instanceof Gmap) {
                this.map = this.options.g2map = g2map.getMap();
            }
            else if (g2map instanceof g2.carto.Map) {
                this.map = this.options.g2map = g2map;
            }


            if (this.options.g2map) {
                if (this.onAdd) this.onAdd();
                this.options.hasEvent && this.addhitTest && this.addhitTest();
                this.options.g2map.addLayer(this);
            }

        },
        /**
         * 移除此图层
         *  @method
         *  @memberOf G.lys.ElementLayerProxy.prototype
         */
        remove: function () {

            if (this.options.g2map) {
                if (this.onRemove) this.onRemove();
                this.options.hasEvent && this.removehitTest && this.removehitTest();
                this.options.g2map.removeLayer(this);
            }
        },
    }
    //为子类继承包含Class的方法；
    Class.defaults(ElementLayerProxy, Class, true)
    //方法继承事件机制
    Class.mixin(ElementLayerProxy, AppEvent.prototype);
    //原型继承g2.lys.ElementLayer
    Class.mixin(ElementLayerProxy, g2.carto.ElementLayer);
    // ElementLayerProxy.include = function (props) {
    //     props = 'prototype' in props ? props.prototype : props;
    //     Class.mixin(this.prototype, props);
    //     return this;
    // };
    //
    // ElementLayerProxy.extend = function (defaults) {
    //     var Sub = function (opts) {
    //         // ElementLayerProxy.call(this, opts);
    //         defaults.initialize && defaults.initialize.call(this, opts);
    //     };
    //     Class.inherits(Sub, this);
    //     for (var name in defaults) {
    //         Sub.prototype[name] = defaults[name];
    //     }
    //     if (defaults.includes) {
    //         Class.mixin.apply(null, [Sub.prototype].concat(defaults.includes));
    //         delete defaults.includes;
    //     }
    //     Sub.include = function (props) {
    //         props = 'prototype' in props ? props.prototype : props;
    //         Class.mixin(this.prototype, props);
    //         return this;
    //     };
    //     if (defaults.options) {
    //         Class.setOptions(Sub, this.options);//
    //         // Sub.options = this.options;
    //     }
    //     return Sub;
    // };
    //
    return ElementLayerProxy;
})


